import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@components/button/button.module';
import { RouteUtils } from '@common/utils/routes/routes';
import { Utils } from '@common/utils/utils';
import { FooterModule } from '@components/footer/footer.module';
import { IonicModule } from '@ionic/angular';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { BaseLayoutComponent } from './base-layout.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    BreadcrumbModule,
    FooterModule,
    ButtonModule,
  ],
  providers: [
    Utils,
    RouteUtils,
  ],
  declarations: [BaseLayoutComponent],
  exports: [BaseLayoutComponent]
})
export class BaseLayoutModule {}
